export default __webpack_public_path__ + "static/media/Background_00098.58e3c469.png";